/* eslint-disable
    func-names,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('lodash');

require('ng-file-upload');

const moduleDeps = [require('data/util').name, 'ngFileUpload'];

const factory = function (Model, Upload, $window, benchLocation, GatewayApi) {
  class File extends Model {
    static initClass() {
      this.prototype.$resource = 'file';
    }

    static $new(file, userId, origin = 'UNKNOWN', type = 'UNKNOWN') {
      const rootUrl = benchLocation.apiRoot();

      const upload = Upload.upload({
        sendFieldsAs: 'form',
        url: GatewayApi.href(`document-upload/${userId}/${file.name}`),
        data: {
          origin,
          type,
          file,
        },
        withCredentials: true,
      });

      return upload;
    }

    static $uploadMultiple(files, userId, origin = 'UNKNOWN', type = 'UNKNOWN') {
      return _.map(files, file => File.$new(file, userId, origin, type));
    }

    static $request(method, request) {
      return function (params = {}) {
        return this.$apiCall({
          method,
          url: `${this.$resource}.json/${this.$storeId()}/${request}`,
          params,
        });
      };
    }

    static $navigate(path) {
      return this.prototype.$apiService.navigate(`/file.json${path}`);
    }

    static downloadList(docIds) {
      const ids = docIds.join();
      return File.$navigate(`/download/list?ids=${ids}`);
    }

    static downloadListAsStatement(docIds) {
      const ids = docIds.join();
      return File.$navigate(`/downloadAsStatement/list?ids=${ids}`);
    }

    static downloadDpFiles(docIds) {
      const ids = docIds.join();
      return File.$navigate(`/downloadDpFiles/list?ids=${ids}`);
    }

    download() {
      return File.$navigate(`/${this.$storeId()}/download`);
    }

    splitAndDownload() {
      return File.$navigate(`/${this.$storeId()}/split_and_download`);
    }

    rotate(page, orientation) {
      return this.$apiCall({
        method: 'PUT',
        url: `${this.$resource}.json/${this.$storeId()}/rotate/${page}/${orientation}`,
        params: {},
      });
    }

    removePage(page) {
      return this.$apiCall({
        method: 'DELETE',
        url: `${this.$resource}.json/${this.$storeId()}/delete_page/${page}/`,
        params: {},
      });
    }

    addPage(id, page, position) {
      return this.$apiCall({
        method: 'PUT',
        url: `${this.$resource}.json/${this.$storeId()}/insert_file/${id}/${position}/${page}/`,
        params: {},
      });
    }
  }
  File.initClass();

  return File;
};

module.exports = angular.module('bench.data.model.file', moduleDeps).factory('File', factory);
